import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  TrackerAddManualActivityConnectorApollo,
  useAppContext,
} from '@front-activerse/common-components';
import TrackerAddEditActivity from '../components/TrackerAddEditActivity';

const AddActivityPage: React.FC = () => {
  const { post } = useAppContext();
  const location = useLocation();
  const activityData = location.state?.activityData;

  const random = Math.random();

  sessionStorage.setItem('tracker_depth', '2');

  return (
    <TrackerAddManualActivityConnectorApollo post={post}>
      {({ addManualActivity }) => (
        <TrackerAddEditActivity
          addManualActivity={addManualActivity}
          activityData={activityData}
          key={random}
        />
      )}
    </TrackerAddManualActivityConnectorApollo>
  );
};

export default AddActivityPage;
